import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {Calendar, DayValue} from "@hassanmojab/react-modern-calendar-datepicker";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {schoolClassInterface} from "../center/add-edit-center-class";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {NumberToPersianLetters} from "../../../components/techaran/money";
import {DateFixToGoLayout, PersianToGregorian} from "../../../components/techaran/date-convert";

export const AdminsAddExtraPaymentModal = (props: { active: boolean, closeHandler: any, onDone: any }) => {
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            setMode('');
            setPrice('');
            setTitle('');
            setClassSelected(0);
            fetchClasses();
            setIsOptional(false);
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const [mode, setMode] = useState('' as '' | 'all' | 'class' | 'students');
    const [price, setPrice] = useState('');
    const [expiresAt, setExpiresAt] = useState<DayValue>(null);
    const [title, setTitle] = useState('');
    const [classes, setClasses] = useState([] as schoolClassInterface[]);
    const [classSelected, setClassSelected] = useState(0);
    const [isOptional, setIsOptional] = useState(false);
    const ids = {
        price: useId(),
        title: useId(),
    };
    const fetchClasses = () => {
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/center/class/get-school-classes',
            {},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                list: schoolClassInterface[] | null,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                let lst: schoolClassInterface[] = d.list === null ? [] : d.list;
                setClasses(lst);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const saveChanges = () => {
        const _mode = mode;
        const _price = price === '' ? 0 : parseInt(price);
        const _optional = isOptional;
        if (expiresAt === null) {
            ShowSnackbar('لطفا تاریخ پایان را مشخص نمایید.', 'باشه', 5000);
            return;
        }
        const _expiresAt = PersianToGregorian(DateFixToGoLayout(`${expiresAt?.year}-${expiresAt?.month}-${expiresAt?.day}`)) + " 23:59:59";
        const _title = title.trim();
        const _classSelected = classSelected;
        if (_title.length < 2) {
            ShowSnackbar('لطفا برای عنوان حداقل ۲ کاراکتر وارد کنید.', 'باشه', 5000);
            return;
        }
        if (!isOptional && _price < 1) {
            ShowSnackbar('لطفا قیمت را بصورت صحیح وارد نمایید.', 'باشه', 5000);
            return;
        }
        if (_mode === 'class' && _classSelected === 0) {
            ShowSnackbar('لطفا یک کلاس را انتخاب نمایید.', 'باشه', 5000);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/extra/add',
            {
                title: _title,
                price: _price.toString(),
                mode: _mode,
                classID: _classSelected.toString(),
                expiresAt: _expiresAt,
                optional:_optional ? '1' : '0',
            },
            true,
            (d: {
                result: string,
                reason: string,
                id: number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    'پرداخت جدید افزوده شد.',
                    'باشه',
                    5000,
                );
                props.onDone();
                props.closeHandler();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-xl" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>افزودن پرداخت</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="container">
                        <div className="add-student">
                            <div className="row">
                                <div className="col-lg-6">
                                    <label htmlFor={ids.title}>عنوان پرداخت:</label>
                                    <input type="text"
                                           id={ids.title}
                                           value={title}
                                           className={"form-control"}
                                           onChange={e => {
                                               const t = e.currentTarget.value;
                                               setTitle(t);
                                           }}
                                    />
                                    <div style={{height: 15}}/>
                                    <button className={"techaran-switch" + (isOptional ? ' active' : '')}
                                            onClick={() => setIsOptional(v => !v)}>
                                        <i><b/></i>
                                        <span>
                                            {isOptional ? 'هزینه انتخابی' : 'هزینه ثابت'}
                                            <em>{isOptional ? 'هزینه توسط والدین تعیین می‌شود.' : 'تنها هزینه وارد شده قابل پرداخت می‌باشد.'}</em>
                                        </span>
                                    </button>
                                    {
                                        !isOptional ?
                                            <>
                                                <label htmlFor={ids.price}>هزینه:</label>
                                                <input type="number"
                                                       id={ids.price}
                                                       min={0}
                                                       value={price}
                                                       className={"form-control"}
                                                       onChange={e => {
                                                           const t = e.currentTarget.value;
                                                           setPrice(t);
                                                       }}
                                                />
                                            </>
                                            : null
                                    }
                                    {
                                        price !== '' ?
                                            <span style={{
                                                display: 'block',
                                                margin: '5px 0 0 0',
                                                fontWeight: 400,
                                                color: '#0a53be'
                                            }}>{NumberToPersianLetters(parseInt(price)) + " تومان"}</span> : null
                                    }
                                    <div style={{height: 15}}/>
                                    <label>نوع:</label>
                                    <button className={"techaran-radio-box" + (mode === 'all' ? ' active' : '')}
                                            onClick={() => setMode('all')}>
                                        <div><i/></div>
                                        <span>همگانی</span>
                                    </button>
                                    <button className={"techaran-radio-box" + (mode === 'class' ? ' active' : '')}
                                            onClick={() => setMode('class')}>
                                        <div><i/></div>
                                        <span>کلاسی</span>
                                    </button>
                                    <button className={"techaran-radio-box" + (mode === 'students' ? ' active' : '')}
                                            onClick={() => setMode('students')}>
                                        <div><i/></div>
                                        <span>افراد خاص</span>
                                    </button>
                                    <div style={{height: 15}}/>
                                    {
                                        mode === 'class' ?
                                            <>
                                                <label style={{display: 'block'}}>کلاس هدف:</label>
                                                {
                                                    classes.map((c, i) =>
                                                        <button key={"Az39r578FF23" + i}
                                                                style={{width: '50%', display: 'inline-flex'}}
                                                                className={"techaran-radio-box" + (classSelected === c.id ? ' active' : '')}
                                                                onClick={() => setClassSelected(c.id)}>
                                                            <div><i/></div>
                                                            <span>{c.title}</span>
                                                        </button>
                                                    )
                                                }
                                                <div style={{height: 15}}/>
                                            </> : null
                                    }
                                </div>
                                <div className="col-lg-6">
                                    <label>تاریخ پایان مهلت پرداخت:</label>
                                    <Calendar
                                        value={expiresAt}
                                        onChange={e => setExpiresAt(e)}
                                        shouldHighlightWeekends
                                        colorPrimary='#0a53be'
                                        locale='fa'
                                    />
                                </div>
                            </div>
                            <div className="d-flex justify-content-end align-items-center"
                                 style={{gap: 20, marginTop: 30}}>
                                <button className="cancel-button" onClick={props.closeHandler}>
                                    <b>انصراف</b>
                                </button>
                                <button className="btn-pay" onClick={saveChanges}>
                                    <b>ذخیره تغییرات</b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};